import { ReactNode } from 'react';
import { StyledTable } from "@/components/ui/Table/styles.ts";
import { SkeletonTable } from "../Loaders/SkeletonTable";

type THeaders = Array<{ text: string; value: string, width?: string }>;

type TableProps<T extends Record<string, any>> = {
    headers: THeaders,
    data: T[],
    tableKey: keyof T;
    children: (props: { value: T[keyof T]; column: keyof T; key: number; item: T }) => ReactNode;
    loading?: boolean;
    withoutBorders?: boolean;
};

export const Table = <T extends Record<string, any>>({ headers, data, tableKey, children, loading, withoutBorders}: TableProps<T>) => {
    if(loading) {
        return <SkeletonTable rows={5} cols={headers.length} />
    }
    return (
        <StyledTable withoutBorders={withoutBorders}>
            <thead>
            <tr>
                {headers.map((header) => (
                    <th key={header.value} style={{ width: header.width }}>{header.text}</th>
                ))}
            </tr>
            </thead>
            <tbody>
            {!!data && !!data.length ? data.map((row) => (
                <tr key={row[tableKey] as number}>
                    {headers.map((header) => (
                        <td key={header.value}>
                            {children({
                                value: row[header.value as keyof T],
                                column: header.value as keyof T,
                                key: row[tableKey] as number,
                                item: row
                            })}
                        </td>
                    ))}
                </tr>
            )) : (
                <tr>
                    <td align='center' colSpan={headers.length} style={{ fontSize: 14 }}>Нет данных</td>
                </tr>
            )}
            </tbody>
        </StyledTable>
    );
};
